import React, { useEffect, useState } from "react";

import { BrowserRouter, Outlet, useNavigate } from "react-router-dom";

import { Box, Chip, IconButton, Menu, MenuItem, Stack } from "@mui/material";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepButton from "@mui/material/StepButton";
import { useSelector, Provider } from "react-redux";
import store from "../Components/redux/store";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { theme } from "../Components/ThemeProvider/ThemeProvider";
import { styled } from "@mui/material/styles";

import { StepIconProps } from "@mui/material/StepIcon";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import ArrowCircleLeftOutlinedIcon from "@mui/icons-material/ArrowCircleLeftOutlined";

import Check from "@mui/icons-material/Check";
import AppStyles from "../App.module.scss";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import backIcon from "../Components/assets/Images/backIcon.svg";

import { stageDetailsAPICall } from "../shared/APICalls";
import routesData from "../shared/routes.json";

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 3,
  borderRadius: 5,
  margin: "0px 0px 0px 0px",
  // width: "93vw",
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor:
      theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.mode === "light" ? "#B1DDC3" : "#308fe8",
  },
}));

interface Props {
  completedStages: any;
  stageName: string;
  navigatePath: string;
  esignBackButtonEnable?: any;
}

export default function StageLayout({
  completedStages,
  stageName,
  navigatePath,
  esignBackButtonEnable,
}: Props) {
  // console.log("completedStages", completedStages);

  const navigate = useNavigate();
  const pathName = useSelector((state: any) => state.PATHNAME.pathname);
  const [step, setStep] = useState<any>(1);
  const [stageDetailsApi, setStageDetailsApi] = useState<any>(0);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClose = (path: any) => {
    setAnchorEl(null);

    if (pathName.includes("ipv") && path.path) {
      window.location.href = path.path;
    } else {
      navigate(path.path);
    }
  };

  const pathToStepMap = {
    "/": -4,
    "/confirm_otp": -3,
    "/yourdetails": -2,
    "/confirmemailotp": -1,
    "/panverification": 1,
    "/aadhaarkyc": 2,
    "/tradingPreference": 3,
    "/yourprofile": 4,
    "/linkusingifsc": 5,
    "/cameramodule": 6,
    "/uploaddocuments": 7,
    "/nomineepage": 8,
    "/termsandconditions": 9,
    "/esign": 10,
    "/congratulations": 11,
  };

  const completed = {
    pan_details: 0,
    fetch_details: 1,
    segment_details: 2,
    profile_page: 3,
    bank_account: 4,
    web_image: 5,
    document_upload: 6,
    nominee_details: 7,
    t_and_c: 8,
    e_sign: 9,
    application_completed: 10,
  };

  const completedStageDetails = {
    pan_details: {
      title: "Pan Verification",
      path: "/panverification",
    },
    profile_page: {
      title: "Profile Details",
      path: "/yourprofile",
    },
    segment_details: {
      title: "Trading Preference",
      path: "/tradingPreference",
    },
    bank_account: {
      title: "Bank Account",
      path: "/bankDetails",
    },
    fatca_details: {
      title: "FATCA",
      path: "/fatca",
    },
    passport_details: {
      title: "Passport Details",
      path: "/passport",
    },
    mobile_details: {
      title: "Mobile Details",
      path: "/mobile",
    },
    nominee_details: {
      title: "Nominee",
      path: "/nomineePage",
    },
    kra_details: {
      title: "KRA",
      path: "/kra",
    },
    overseas_address: {
      title: "Overseas Address",
      path: "/overseasAddress",
    },
    address_details: {
      title: "Address Details",
      path: "/addressDetails",
    },
    pis_bank_account: {
      title: "PIS Bank",
      path: "/pisBank",
    },
    document_upload: {
      title: "Documents Upload",
      path: "/uploaddocuments",
    },
    web_image: {
      title: "IPV",
      path: "/ipv",
    },
  };

  useEffect(() => {
    Object.keys(pathToStepMap).forEach((path) => {
      if (pathName.includes(path)) {
        //  setStep(pathToStepMap[path]);
        setStageDetailsApi(pathToStepMap[path]);
        //console.log(pathToStepMap[path]);
      }
    });
  }, [pathName]);

  useEffect(() => {
    if (stageDetailsApi > 0) {
      let obj: any = {
        stage: "document_upload",
      };

      if (completedStages) {
        const matchedRoutes: any = [];
        completedStages.forEach((route) => {
          if (completed.hasOwnProperty(route)) {
            matchedRoutes.push(completed[route]);
          }
          // console.log("matchedRoutes", matchedRoutes.length);
          // setStep(matchedRoutes.length);
          setStep(matchedRoutes.length);
        });
      }
    }
  }, [stageDetailsApi, completedStages]);

  const handleBackClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const filteredStage = completedStages?.filter((a:any)=>a !=="pan_details" && a !== "kra_details")

  return (
    <>
      <Stack style={{ overflowX: "hidden" }}>
        <>
          <Box
            sx={{
              width: "100%",
              margin: { xs: "0 2px", md: "0 10px" },
              zIndex: 100,
              position: "relative",
              // top: "50px",
              // paddingTop: "5px",
            }}
          >
            <Box sx={{ flexGrow: 1 }}>
              <BorderLinearProgress
                variant="determinate"
                value={completedStages ? completedStages.length * 8 : 10}
              />
            </Box>
          </Box>
          <Stack alignItems={"flex-start"}>
            <div style={{ marginTop: "5px", marginLeft: "3%" }}>
              <>
                <IconButton
                  onClick={(event: any) => {
                    handleBackClick(event);
                  }}
                >
                  <img
                    src={backIcon}
                    style={{
                      background: "white",
                      transform: open ? "rotate(-90deg)" : "",
                      transition: "all 0.3s",
                    }}
                  />
                </IconButton>
                {filteredStage?.length > 0 && (
                  <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                      "aria-labelledby": "basic-button",
                    }}
                  >
                    {filteredStage &&
                      filteredStage.map((a: any) => (
                        <MenuItem
                          onClick={() => {
                            handleClose(completedStageDetails[a]);
                          }}
                        >
                          {completedStageDetails[a].title}
                        </MenuItem>
                      ))}
                  </Menu>
                )}
              </>
              <Chip
                sx={{
                  border: "1px solid #006779",
                  backgroundColor: "#CCE1E4",
                  marginTop:
                    pathName.includes("aadhaar") ||
                    pathName.includes("yourprofile") ||
                    esignBackButtonEnable === "DocumentReceived"
                      ? "5px"
                      : 0,
                }}
                label={stageName}
                variant="outlined"
              />
            </div>
          </Stack>
        </>
      </Stack>
    </>
  );
}
